export default class User {
    constructor(user){
        this.id =user.id;
        this.name =user.name;
        this.aboutShort =user.aboutShort;
        this.lastPostDate =user.lastPostDate;
        this.avatarUrl =user.avatarUrl;
    }
}


// WEBPACK FOOTER //
// ./src/entities/User.js